import { render, staticRenderFns } from "./ReviseUser.vue?vue&type=template&id=ff9922ce&"
import script from "./ReviseUser.vue?vue&type=script&lang=js&"
export * from "./ReviseUser.vue?vue&type=script&lang=js&"
import style0 from "./ReviseUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports